export const CREATE_DELIVERY_CHALLAN = 'CREATE_DELIVERY_CHALLAN';
export const GET_DELIVERY_CHALLANS = 'GET_DELIVERY_CHALLANS';
export const DELIVERY_CHALLAN_REQUEST = 'DELIVERY_CHALLAN_REQUEST';
export const GET_DELIVERY_CHALLAN_PAGE = 'GET_DELIVERY_CHALLAN_PAGE';
export const DELIVERY_CHALLAN_REQUEST_SUCCESS = 'DELIVERY_CHALLAN_REQUEST_SUCCESS';
export const UPDATE_DELIVERY_CHALLAN = 'UPDATE_DELIVERY_CHALLAN';
export const DELETE_DELIVERY_CHALLAN = 'DELETE_DELIVERY_CHALLAN';
export const DELIVERY_CHALLAN_REQUEST_FAILURE = 'DELIVERY_CHALLAN_REQUEST_FAILURE';
export const GET_LAST_FIVE_DELIVERY_CHALLANS = 'GET_LAST_FIVE_DELIVERY_CHALLANS';